import { Ref } from 'react';

import { Calendar } from 'primereact/calendar';
import { UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { Task } from 'types/interfaces';

import { CalendarOnChangeEvent } from 'ui/custom-controls/DateTimeInput';

import { calendarFormatDateString } from '../../../utils/date-utils';

interface UseTaskDatesProps {
  setValue: UseFormSetValue<Task>;
  trigger: UseFormTrigger<Task>;
}

export function useTaskDates(props: UseTaskDatesProps) {
  const { setValue, trigger } = props;
  
  const handleStartDateChange = async (event: CalendarOnChangeEvent) => {
    const selectedDate = event.value as Date | null;
    if (selectedDate instanceof Date) {
      const formattedDate = calendarFormatDateString(selectedDate);
      await setValue('actualStartDate', formattedDate, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      await setValue('actualStartDate', '', {
        shouldDirty: true,
        shouldValidate: true
      });
    }
    await trigger('actualStartDate');
    await trigger('plannedEndDate');
    await trigger('actualEndDate');
  };

  const handleEndDateChange = async (
    event: CalendarOnChangeEvent,
    field: 'plannedEndDate' | 'actualEndDate'
  ) => {
    const selectedDate = event.value as Date | null;
    if (selectedDate instanceof Date) {
      const formattedDate = calendarFormatDateString(selectedDate);
      await setValue(field, formattedDate, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      await setValue(field, '', { shouldDirty: true, shouldValidate: true });
    }
    await trigger(field);
    await trigger('actualStartDate');
  };

  const handlePlannedStartDateChange = async (event: CalendarOnChangeEvent) => {
    const selectedDate = event.value as Date | null;
    if (selectedDate instanceof Date) {
      const formattedDate = calendarFormatDateString(selectedDate);
      await setValue('plannedStartDate', formattedDate, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      await setValue('plannedStartDate', '', {
        shouldDirty: true,
        shouldValidate: true
      });
    }
    await trigger('plannedStartDate');
    await trigger('plannedEndDate');
  };

  const CalendarHideHandle = (ref: Ref<Calendar>) => {
    if (ref && 'current' in ref && ref.current !== null) {
      ref.current.hide();
    }
  };

  return {
    handleStartDateChange,
    handleEndDateChange,
    handlePlannedStartDateChange,
    CalendarHideHandle
  };
}
